import React from 'react';
import { SystemDashboardLayout} from 'library';
import HeaderDashboard from 'Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import ProjectScoreCard from 'Components/ProjectScoreCard/ProjectScoreCard'
import AddProjectScoreCardVersion from 'Components/ProjectScoreCard/AddProjectScoreCardVersion';


const ProjectScoreCardDashboard = (props: any) => {

    const onRowClick = (event: any) => {
        if (event && event.dataItem.PrimaryKeyEncrypted) {
            props.history.push({
                pathname: `/edit-score-card-version/${event.dataItem.PrimaryKeyEncrypted}`,
                data: event.dataItem
            });
        }
    }

    const onAdd = () => {
        props.history.push({
            pathname: '/add-score-card-version',
        });
        return ""
    }

    return (<>
        <div className="DashboardWrapperChild">           
            <div className="contentWrapper">
                <HeaderDashboard title="Top" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">                       
                        <div className="col-md-12">                         
                            <SystemDashboardLayout>
                                <SystemGridAndForm label="Score Card Version" form={AddProjectScoreCardVersion} grid={ProjectScoreCard} securityObject="Top.ScoreCardVersions" onRowClick={onRowClick} onAdd={onAdd} />
                            </SystemDashboardLayout>
                        </div>
                    </div>
                </div>
            </div>
        </div>     
    </>)
}

export default ProjectScoreCardDashboard;